import { makeEnum } from '@transcend-io/type-utils';

/**
 * Business category classifications for services and tools
 */
export const IntegrationCategory = makeEnum({
  /** Advertising & Marketing related services and tools */
  AdvertisingAndMarketing: 'ADVERTISING_AND_MARKETING',
  /** Analytics & Business Intelligence platforms and solutions */
  AnalyticsAndBusinessIntelligence: 'ANALYTICS_AND_BUSINESS_INTELLIGENCE',
  /** Collaboration & Productivity tools and software */
  CollaborationAndProductivity: 'COLLABORATION_AND_PRODUCTIVITY',
  /** Computing Infrastructure services and platforms */
  ComputingInfrastructure: 'COMPUTING_INFRASTRUCTURE',
  /** Content & Media management and creation tools */
  ContentAndMedia: 'CONTENT_AND_MEDIA',
  /** Customer Support & Experience management solutions */
  CustomerSupportAndExperience: 'CUSTOMER_SUPPORT_AND_EXPERIENCE',
  /** Databases and Storage solutions */
  DatabasesAndStorage: 'DATABASES_AND_STORAGE',
  /** E-commerce & Retail platforms and services */
  EcommerceAndRetail: 'ECOMMERCE_AND_RETAIL',
  /** Finance & Payments processing and management tools */
  FinanceAndPayments: 'FINANCE_AND_PAYMENTS',
  /** HR & Workforce management systems */
  HrAndWorkforce: 'HR_AND_WORKFORCE',
  /** Sales & CRM platforms and tools */
  SalesAndCrm: 'SALES_AND_CRM',
  /** Security & Compliance solutions and services */
  SecurityAndCompliance: 'SECURITY_AND_COMPLIANCE',
  /** Software Development & DevOps tools and platforms */
  SoftwareDevelopmentAndDevops: 'SOFTWARE_DEVELOPMENT_AND_DEVOPS',
  /** Transcend custom integrations */
  TranscendCustom: 'TRANSCEND_CUSTOM',
  /** Other categories not covered by the above options */
  Other: 'OTHER',
});

/** Type override */
export type IntegrationCategory =
  (typeof IntegrationCategory)[keyof typeof IntegrationCategory];
